export default "__VITE_ASSET__D_oOrbtl__"